<template>
  <div class="color-input-wrapper">
    <div
      class="color-picker-value rounded"
      :style="{ backgroundColor: displayColor }"
      @click="openColorPickerModal"
    ></div>
    <button
      v-if="clearable && value"
      type="button"
      class="btn btn-sm btn-secondary ml-2"
      @click="clearColor"
    >
      Clear
    </button>
    <modal
      class="color-picker-modal"
      :name="modalName"
      transition="pop-out"
      :height="450"
      :width="350"
      v-model="showModal"
    >
      <div class="position-relative">
        <div class="vm--top-right-slot" style="z-index: 1">
          <button
            type="button"
            class="btn p-0 pr-3 pt-3 border-0"
            @click="closeColorPickerModal"
          >
            <i class="fas fa-times fa-lg"></i>
          </button>
        </div>
        <div class="card-body">
          <ColorPicker
            :color="selectedColor"
            :onStartChange="onColorChange"
            :onChange="onColorChange"
            :onEndChange="onColorChange"
          />
          <div
            class="
              col-12
              p-0
              d-flex
              justify-content-center
              mt-3
              border-top
              pt-4
            "
          >
            <button type="button" class="btn btn-theme" @click="confirmColor">
              <icon :type="iconType" class="mr-2" /> Confirm Color
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { ColorPicker } from "vue3-color-gradient-picker";

export default {
  name: "ColorInput",
  components: {
    ColorPicker,
  },
  props: {
    iconType: {
      type: String,
      default: "check-circle",
    },
    value: {
      type: String,
      default: null,
    },
    defaultColor: {
      type: String,
      default: "204, 204, 204, 1",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showModal: false,
      modalName: `color-picker-modal-${this._uid}`,
      selectedColor: {
        red: 204,
        green: 204,
        blue: 204,
        alpha: 1,
      },
      lastScrollPosition: 0,
    };
  },
  computed: {
    displayColor() {
      if (this.value) {
        return `rgba(${this.value})`;
      }
      return `rgba(${this.defaultColor})`;
    },
  },
  methods: {
    parseColorToRgba(colorString) {
      if (!colorString) {
        const defaults = this.defaultColor.split(",");
        return {
          red: parseInt(defaults[0] || 204),
          green: parseInt(defaults[1] || 204),
          blue: parseInt(defaults[2] || 204),
          alpha: parseFloat(defaults[3] || 1),
        };
      }
      const colors = colorString.split(",");
      return {
        red: parseInt(colors[0] || 204),
        green: parseInt(colors[1] || 204),
        blue: parseInt(colors[2] || 204),
        alpha: parseFloat(colors[3] || 1),
      };
    },
    onColorChange(color) {
      this.selectedColor = { ...color };
    },
    /**
     * The scroll added here because of an issue with
     * the color picker package modal calculating positions
     * incorrectly when the page is scrolled down.
     */
    openColorPickerModal() {
      this.lastScrollPosition =
        window.scrollY || document.documentElement.scrollTop;
      this.selectedColor = this.parseColorToRgba(this.value);
      // Scroll to top for color picker to calculate positions correctly
      window.scrollTo(0, 0);
      this.showModal = true;
    },
    closeColorPickerModal() {
      this.showModal = false;
      // Restore scroll position after modal closes
      this.$nextTick(() => {
        window.scrollTo(0, this.lastScrollPosition);
      });
    },
    confirmColor() {
      const colorValue = `${this.selectedColor.red}, ${this.selectedColor.green}, ${this.selectedColor.blue}, ${this.selectedColor.alpha}`;
      this.$emit("input", colorValue);
      this.closeColorPickerModal();
    },
    clearColor() {
      this.$emit("input", null);
    },
  },
};
</script>

<style scoped lang="scss">
.color-input-wrapper {
  display: flex;
  align-items: center;
}

.color-picker-value {
  box-shadow: 0px 0px 6px 0px #062157;
  width: 40px;
  height: 30px;
  cursor: pointer;
}
</style>
